/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardRequest {
    getFixupPrototypeFunction() { return SecurityDashboardRequest.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardRequest>): SecurityDashboardRequest {
        let obj = Object.assign(new SecurityDashboardRequest(), model);
        SecurityDashboardRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardRequest>): SecurityDashboardRequest {
        if (!model) return null;
        return SecurityDashboardRequest.newInstance(<SecurityDashboardRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardRequest) {
        if (!obj) return;

        models.SecurityDashboardRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardRequest): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filter) {
            models.SecurityDashboardAccountFilters.fixupPrototype(this.filter);
        }
    }

    filter: models.SecurityDashboardAccountFilters;

}
